module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    attrs: {
      "name": _vm.modulename,
      "loading": _vm.loading,
      "backRoute": "moduleIntegral",
      "param": _vm.params
    }
  }, [_c('template', {
    slot: "detailMain"
  }, [_c('span', {
    staticClass: "searchName"
  }, [_vm._v("自定义时间段:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "kuang",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "daterange",
      "clearable": false,
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeData
    },
    model: {
      value: (_vm.tiemSlot),
      callback: function($$v) {
        _vm.tiemSlot = $$v
      },
      expression: "tiemSlot"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#2196F3"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("共" + _vm._s(_vm.count) + "人使用")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": "545px",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "companyname",
      "label": "企业",
      "min-width": "230",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allpoint",
      "label": "产生积分",
      "width": "130",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#669DF0"
          }
        }, [_vm._v(_vm._s(scope.row.allpoint))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes,prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNumber,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.pageNumber = $event
      },
      "update:current-page": function($event) {
        _vm.pageNumber = $event
      },
      "current-change": _vm.changeData
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-991073e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/console/assembly/moduleUserDetail.vue
// module id = 1765
// module chunks = 9